var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-docs 1",
    clipPath: "url(#clip0_856_2266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.46875 24.5H19.5312C20.6944 24.5 21.6406 23.5538 21.6406 22.3906V7.53125H16.7188C15.5556 7.53125 14.6094 6.58503 14.6094 5.42188V0.5H5.46875C4.30559 0.5 3.35938 1.44622 3.35938 2.60938V22.3906C3.35938 23.5538 4.30559 24.5 5.46875 24.5ZM8.28125 10.3906H16.7188C17.1074 10.3906 17.4219 10.7051 17.4219 11.0938C17.4219 11.4824 17.1074 11.7969 16.7188 11.7969H8.28125C7.89261 11.7969 7.57812 11.4824 7.57812 11.0938C7.57812 10.7051 7.89261 10.3906 8.28125 10.3906ZM8.28125 13.2031H16.7188C17.1074 13.2031 17.4219 13.5176 17.4219 13.9062C17.4219 14.2949 17.1074 14.6094 16.7188 14.6094H8.28125C7.89261 14.6094 7.57812 14.2949 7.57812 13.9062C7.57812 13.5176 7.89261 13.2031 8.28125 13.2031ZM8.28125 16.0156H16.7188C17.1074 16.0156 17.4219 16.3301 17.4219 16.7188C17.4219 17.1074 17.1074 17.4219 16.7188 17.4219H8.28125C7.89261 17.4219 7.57812 17.1074 7.57812 16.7188C7.57812 16.3301 7.89261 16.0156 8.28125 16.0156ZM8.28125 18.8281H13.9062C14.2949 18.8281 14.6094 19.1426 14.6094 19.5312C14.6094 19.9199 14.2949 20.2344 13.9062 20.2344H8.28125C7.89261 20.2344 7.57812 19.9199 7.57812 19.5312C7.57812 19.1426 7.89261 18.8281 8.28125 18.8281Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7188 6.12512H21.2286L16.0156 0.912109V5.422C16.0156 5.80994 16.3308 6.12512 16.7188 6.12512Z",
    fill: "#2EBB49"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_2266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDocs);
export default __webpack_public_path__ + "static/media/google-docs.6cb0eae1c13a740d5152d9530ec3dd05.svg";
export { ForwardRef as ReactComponent };